/* assets/br-featured-quote.js — see docs/CUSTOMER-STORIES-FEATURED-QUOTE.md */
class FeaturedQuote extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.br-featured-quote__slide'));
    this.live = this.querySelector('.br-featured-quote__slides');
    this.pauseBtn = this.querySelector('[data-fq-pause]');
    if (this.slides.length < 2) return;

    this.at = 0;
    this.interval = (parseInt(this.dataset.interval, 10) || 10) * 1000;
    this.stopped = false;

    this.querySelectorAll('[data-fq-step]').forEach(btn =>
      btn.addEventListener('click', () => {
        this.show(this.at + parseInt(btn.dataset.fqStep, 10));
        this.restart();
      }));

    this.pauseBtn?.addEventListener('click', () => this.toggle());

    // Hover and keyboard focus both hold the rotation, so a quote is never
    // pulled away mid-read. Neither counts as stopping it for good.
    this.addEventListener('mouseenter', () => this.hold());
    this.addEventListener('mouseleave', () => this.release());
    this.addEventListener('focusin', () => this.hold());
    this.addEventListener('focusout', () => this.release());

    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.reduced.matches) this.setStopped(true);
    else this.start();
  }

  show(i) {
    const n = this.slides.length;
    this.at = ((i % n) + n) % n;
    // Class, not the hidden attribute: the slides stay stacked in the grid
    // so the section's height never changes between quotes.
    this.slides.forEach((s, k) => { s.classList.toggle('is-active', k === this.at); });
  }

  start() {
    this.stop();
    if (this.stopped || this.held) return;
    this.timer = setInterval(() => this.show(this.at + 1), this.interval);
  }

  stop() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  restart() {
    this.stop();
    this.start();
  }

  hold() { this.held = true; this.stop(); }

  release() {
    this.held = false;
    this.start();
  }

  toggle() { this.setStopped(!this.stopped); }

  setStopped(stopped) {
    this.stopped = stopped;
    if (stopped) this.stop(); else this.start();
    if (this.pauseBtn) {
      this.pauseBtn.setAttribute('aria-pressed', String(stopped));
      const label = this.pauseBtn.querySelector('.br-featured-quote__pause-text');
      if (label) label.textContent = stopped ? 'Play quotes' : 'Pause quotes';
    }
    // Announce slide changes only once rotation is not driving them.
    if (this.live) this.live.setAttribute('aria-live', stopped ? 'polite' : 'off');
  }

  disconnectedCallback() { this.stop(); }
}

if (!customElements.get('featured-quote')) {
  customElements.define('featured-quote', FeaturedQuote);
}
